import { z } from 'zod';

export const STORE_NAMES_STORAGE_KEY = 'conversionAnalytics.storeNames';

export const getStoredStoreName = (clubId: string): string | null => {
  if (clubId === 'all' || typeof window === 'undefined') return null;

  try {
    const storeNames = JSON.parse(localStorage.getItem(STORE_NAMES_STORAGE_KEY) ?? '{}') as Record<string, string>;
    return storeNames[clubId] ?? null;
  } catch {
    return null;
  }
};

export const storeStoreName = (clubId: string, storeName: string): void => {
  try {
    const storeNames = JSON.parse(localStorage.getItem(STORE_NAMES_STORAGE_KEY) ?? '{}') as Record<string, string>;
    localStorage.setItem(STORE_NAMES_STORAGE_KEY, JSON.stringify({ ...storeNames, [clubId]: storeName }));
  } catch {
    // The table response remains available as a fallback when local storage is unavailable.
  }
};

export const clearStoredStoreNames = (): void => {
  try {
    localStorage.removeItem(STORE_NAMES_STORAGE_KEY);
  } catch {
    // Local storage may be unavailable in restricted browser contexts.
  }
};

const conversionAnalyticsSortSchema = z.object({
  id: z.enum([
    'storeName',
    'reservationStore',
    'hostDetails',
    'phoneStore',
    'phoneHost',
    'totalClick',
    'actionType',
    'sourcePage',
    'targetName',
    'userStatus',
    'prefecture',
    'browsers',
    'createdDate',
  ]),
  desc: z.boolean(),
});

export const conversionAnalyticsSearchSchema = z
  .object({
    activeTab: z.enum(['overview', 'activity-log']).default('overview'),
    clubId: z.string().default('all'),
    channel: z.enum(['all', 'phone', 'reservation']).default('all'),
    createdDate: z.string().optional(),
    actionType: z.string().optional(),
    sourcePageType: z.string().optional(),
    userStatus: z.string().optional(),
    sort: z.preprocess((value) => {
      if (typeof value === 'string') {
        try {
          return JSON.parse(value);
        } catch {
          return undefined;
        }
      }
      return value;
    }, z.array(conversionAnalyticsSortSchema).optional()),
    q: z
      .any()
      .transform((value) => (value == null ? undefined : String(value)))
      .optional(),
    page: z.coerce.number().nonnegative().catch(0),
    fetch: z.coerce.number().positive().max(100).catch(10),
  })
  .passthrough();
